import { Stack as ChakraStack, StackProps, HStack as ChakraHStack, VStack as ChakraVStack } from '@chakra-ui/react'
import { withShade } from './utils'

export const Stack = withShade<StackProps>(ChakraStack)
export const HStack = withShade<StackProps>(ChakraHStack)
export const VStack = withShade<StackProps>(ChakraVStack)
